import HomeNavbar from "../components/HomeNavbar";
import HomeFooter from "../components/HomeFooter";
import "../components/HomeHF.css";

export default function PrivacyPolicy() {
  return (
    <div>
        <HomeNavbar/>

        <main class="container-pagecomp">
            
            <section>
                <h1>Privacy Policy</h1>

                <p class="updated">
                    Last Updated: May 9, 2026
                </p>

                <p>
                    <strong>CreatorComment</strong> respects your privacy.
                </p>

                <p>
                    This Privacy Policy explains how we collect, use, and protect your
                    information.
                </p>
            </section>

            <section>
                <h2>1. Information We Collect</h2>

                <p>We may collect:</p>

                <ul>
                    <li>Email address</li>
                    <li>Account information</li>
                    <li>YouTube video IDs</li>
                    <li>YouTube comments and metadata</li>
                    <li>Usage analytics</li>
                    <li>Billing information (via payment providers)</li>
                </ul>
            </section>

            <section>
                <h2>2. How We Use Information</h2>

                <p>We use collected information to:</p>

                <ul>
                    <li>Provide AI analysis</li>
                    <li>Improve platform features</li>
                    <li>Process subscriptions</li>
                    <li>Monitor performance and abuse</li>
                    <li>Provide support</li>
                </ul>
            </section>

            <section>
                <h2>3. AI Processing</h2>

                <p>
                    Comments and related content may be processed using third-party AI
                    providers such as:
                </p>

                <ul>
                    <li>OpenAI</li>
                    <li>Google AI services</li>
                </ul>

                <p>
                    Data is processed only for generating insights and platform
                    functionality.
                </p>
            </section>

            <section>
                <h2>4. Data Storage</h2>

                <p>We may store:</p>

                <ul>
                    <li>Analysis history</li>
                    <li>Generated insights</li>
                    <li>Usage logs</li>
                </ul>

                <p>
                    Data is stored securely using cloud infrastructure such as Firebase.
                </p>
            </section>

            <section>
                <h2>5. Third-Party Services</h2>

                <p>
                    CreatorComment uses third-party services including:
                </p>

                <ul>
                    <li>YouTube API Services</li>
                    <li>Firebase</li>
                    <li>Stripe</li>
                    <li>OpenAI</li>
                </ul>

                <p>
                    Your use of CreatorComment is also subject to their policies.
                </p>
            </section>

            <section>
                <h2>6. Cookies &amp; Analytics</h2>

                <p>
                    We may use cookies and analytics tools to:
                </p>

                <ul>
                    <li>Improve user experience</li>
                    <li>Monitor performance</li>
                    <li>Understand usage behavior</li>
                </ul>
            </section>

            <section>
                <h2>7. Data Security</h2>

                <p>
                    We take reasonable measures to protect your information.
                </p>

                <p>
                    However, no platform is completely secure.
                </p>
            </section>

            <section>
                <h2>8. User Rights</h2>

                <p>You may request:</p>

                <ul>
                    <li>Account deletion</li>
                    <li>Removal of stored data</li>
                </ul>

                <p>By contacting us.</p>
            </section>

            <section>
                <h2>9. Children's Privacy</h2>

                <p>
                    CreatorComment is not intended for children under 13.
                </p>
            </section>

            <section>
                <h2>10. Changes to Policy</h2>

                <p>
                    We may update this Privacy Policy periodically.
                </p>

                <p>
                    Continued use of the platform means acceptance of updates.
                </p>
            </section>

            <section>
                <h2>11. Contact</h2>

                <p>For privacy-related questions:</p>

                <p>
                    <a href="mailto:creatorcommentweb@gmail.com">
                    creatorcommentweb@gmail.com
                    </a>
                </p>
            </section>
            

        </main>

      <HomeFooter/>
    </div>
  );
}